export default "__VITE_ASSET__HhdwPf9p__"